export default __webpack_public_path__ + "static/media/CareConnectLogo_3.a56d8673.png";